"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CTAButton_1 = __importDefault(require("../call-to-action/CTAButton"));
var elements_1 = require("../elements/");
var Text_1 = __importDefault(require("../elements/Text"));
var Image_1 = __importDefault(require("../elements/Image"));
var Headline_1 = require("../../defaults/Headline");
var HeroHeader_1 = require("../../defaults/HeroHeader");
var Icon_1 = __importDefault(require("../elements/Icon"));
var VideoPlayer_1 = __importDefault(require("../elements/VideoPlayer"));
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var _styled_1 = require("../../styled-components");
var HeroHeaderDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  background-size: cover;\n  min-height: 100vh;\n  background-attachment: ", ";\n"], ["\n  background: ",
    ";\n  background-size: cover;\n  min-height: 100vh;\n  background-attachment: ", ";\n"])), function (_a) {
    var dark = _a.dark, theme = _a.theme, backgroundImage = _a.backgroundImage, backgroundColor = _a.backgroundColor;
    if (backgroundColor)
        return backgroundColor;
    if (backgroundImage && backgroundImage.overlay)
        return "linear-gradient(\n    " + backgroundImage.overlay + ",\n    " + backgroundImage.overlay + "\n    ), " + backgroundImage.src;
    if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src)
        return backgroundImage.src;
    if (dark)
        return theme.bgDark;
    return theme.bgLight;
}, function (_a) {
    var fixed = _a.fixed;
    return (fixed ? 'fixed' : 'scroll');
});
var Layer = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-height: 100vh;\n  background: ", ";\n\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"], ["\n  min-height: 100vh;\n  background: ",
    ";\n\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])), function (_a) {
    var dark = _a.dark, backgroundColor = _a.backgroundColor;
    return backgroundColor
        ? backgroundColor
        : dark
            ? 'rgba(0, 0, 0, 0.7)'
            : 'rgba(255, 255, 255, 0.7)';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
});
var Item = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  margin: 0 0 10px;\n"], ["\n  display: flex;\n  margin: 0 0 10px;\n"])));
var ContentDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: flex !important;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: flex !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
});
var TextContentDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  order: 1;\n  @media (min-width: ", ") {\n    order: ", ";\n  }\n"], ["\n  order: 1;\n  @media (min-width: ", ") {\n    order: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
}, function (_a) {
    var variant = _a.variant;
    return (variant === 1 ? 0 : 1);
});
var MediaContentDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  order: 0;\n  @media (min-width: ", ") {\n    order: ", ";\n  }\n"], ["\n  order: 0;\n  @media (min-width: ", ") {\n    order: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
}, function (_a) {
    var variant = _a.variant;
    return (variant === 1 ? 1 : 0);
});
var Headline = function (_a) {
    var _b = _a.dark, dark = _b === void 0 ? true : _b, labelConfig = _a.labelConfig, titleConfig = _a.titleConfig, descriptionConfig = _a.descriptionConfig, hrConfig = _a.hrConfig;
    var mergedLabelConfig = _helpers_1.merge(Headline_1.defaultLabelConfig, labelConfig);
    var mergedTitleConfig = _helpers_1.merge(Headline_1.defaultTitleConfig, titleConfig);
    var mergedDescriptionConfig = _helpers_1.merge(Headline_1.defaultDescriptionConfig, descriptionConfig);
    return (react_1.default.createElement("div", { className: "columns is-centered" },
        react_1.default.createElement("div", { className: "column is-12-mobile is-10-desktop pt-0 pb-0" },
            (mergedLabelConfig === null || mergedLabelConfig === void 0 ? void 0 : mergedLabelConfig.text) && react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedLabelConfig)),
            react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedTitleConfig)),
            hrConfig && react_1.default.createElement(elements_1.Hr, __assign({}, hrConfig)),
            (mergedDescriptionConfig === null || mergedDescriptionConfig === void 0 ? void 0 : mergedDescriptionConfig.text) && (react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedDescriptionConfig))))));
};
var TextContent = function (_a) {
    var variant = _a.variant, dark = _a.dark, items = _a.items;
    return (react_1.default.createElement(TextContentDiv, { variant: variant, className: "column is-variable is-12-mobile is-12-tablet is-12-desktop is-6-widescreen" }, items.map(function (item, i) { return (react_1.default.createElement(Item, { dark: dark, key: i },
        item.iconConfig && (react_1.default.createElement(Icon_1.default, __assign({ dark: dark }, HeroHeader_1.defaultItemIconConfig, item.iconConfig))),
        react_1.default.createElement("div", null,
            item.title && (react_1.default.createElement(Text_1.default, { text: item.title, dark: dark, size: 6, margin: { desktop: 0, tablet: 0, mobile: 0 }, spanConfig: item.spanConfig, defaultCss: { textAlign: 'left' } })),
            item.text && (react_1.default.createElement(Text_1.default, { text: item.text, fontSize: '1rem', dark: dark, spanConfig: item.spanConfig }))))); })));
};
var MediaContent = function (_a) {
    var variant = _a.variant, dark = _a.dark, onClick = _a.onClick, cta = _a.cta, video = _a.video, image = _a.image;
    return (react_1.default.createElement(MediaContentDiv, { variant: variant, className: "column is-variable is-12-mobile is-12-tablet is-12-desktop is-6-widescreen" },
        (video === null || video === void 0 ? void 0 : video.src) && react_1.default.createElement(VideoPlayer_1.default, { url: video.src }),
        image && react_1.default.createElement(Image_1.default, __assign({}, image)),
        react_1.default.createElement("br", null),
        onClick && react_1.default.createElement(CTAButton_1.default, __assign({ dark: dark, full: true }, cta, { onClick: onClick }))));
};
var HeroHeader = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 1 : _b, _c = _a.dark, dark = _c === void 0 ? true : _c, _d = _a.fixed, fixed = _d === void 0 ? false : _d, backgroundImage = _a.backgroundImage, backgroundColor = _a.backgroundColor, labelConfig = _a.labelConfig, titleConfig = _a.titleConfig, descriptionConfig = _a.descriptionConfig, _e = _a.padding, padding = _e === void 0 ? HeroHeader_1.defaultLayerConfig.padding : _e, benefits = _a.benefits, video = _a.video, image = _a.image, onClick = _a.onClick, _f = _a.hrConfig, hrConfig = _f === void 0 ? {
        defaultCss: { color: dark ? '#fff' : '#000' }
    } : _f, cta = _a.cta;
    return (react_1.default.createElement(HeroHeaderDiv, { variant: variant, dark: dark, fixed: fixed, backgroundImage: backgroundImage, backgroundColor: backgroundColor },
        react_1.default.createElement(Layer, { dark: dark, backgroundColor: backgroundColor, padding: padding },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement(Headline, { dark: dark, labelConfig: labelConfig, titleConfig: titleConfig, descriptionConfig: descriptionConfig, hrConfig: hrConfig }),
                react_1.default.createElement(ContentDiv, { className: "columns is-multiline" },
                    react_1.default.createElement(TextContent, { items: benefits, variant: variant, dark: dark }),
                    react_1.default.createElement(MediaContent, { variant: variant, dark: dark, onClick: onClick, video: video, image: image, cta: cta }))))));
};
exports.default = HeroHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=HeroHeader.js.map